<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            :search="false"
        >
            <template slot="columns">
                <el-table-column label="类目" align="center">
                    <template slot-scope="{ row }">
                        {{ { contact_code: "客服二维码", contact_mobile: "电话" }[row.name] }}
                    </template>
                </el-table-column>
                <el-table-column label="内容" align="center" prop="value">
                    <template slot-scope="{ row }">
                        <img
                            @click="handlePreview(row.value)"
                            style="height: 100px"
                            v-if="row.name === 'contact_code'"
                            :src="ossUrl + row.value"
                            alt=""
                        />
                        <div v-else>{{ row.value }}</div>
                    </template>
                </el-table-column>
                <el-table-column v-if="permission('nrgl_contact_gx')" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleUpdate(row)"> 更新 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
        <PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import { ossUrl } from "@/configs/oss";
import { list } from "@/api/content/contact";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";
import PicPreviewer from "@/components/PicPreviewer";

export default {
    components: { FormVue, PicPreviewer },
    data() {
        return {
            list,
            ossUrl,
            // 查询参数
            query: {
                search: "",
            },
        };
    },
    mounted() {
        this.search();
    },
    mixins: [listMixin],
    methods: {
        search() {
            this._search();
        },
        handleUpdate(row) {
            this.$refs.form.open(row);
        },
        handlePreview(url) {
            this.$refs.preview.open(url);
        },
    },
};
</script>
